import React from 'react';

import { TestCoreComponentProps } from '@bcp-channels-sharedcomponents-reactjs/core';
import { render } from '@testing-library/react';

import { TestComponent } from '../testComponent';

interface TestHookProps {
	hookFn: () => any;
	state?: Record<string, any>;
	coreProps?: TestCoreComponentProps;
}

export const TestHook: React.FC<TestHookProps> = ({ state, coreProps, hookFn }) => {
	const Setup: React.FC = () => {
		const returnVal = {};
		function TestComp() {
			Object.assign(returnVal, hookFn());
			return null;
		}
		render(
			<TestComponent coreProps={coreProps}>
				<TestComp />
			</TestComponent>
		);
		return returnVal as any;
	};

	return <Setup />;
};
